/* eslint-disable no-unused-vars */
import { useId } from 'react';
import * as S from '../../AudienceManagement.styled';
import { CopyIcon } from 'assets/icons';
import {
  IconButton,
  CustomInput,
  CopyString,
  ErrorComponent,
  Loader,
  ImageWithFallback,
} from 'components';
import { globalAPI } from 'services/global.service';

export const ThirdPartyAudience = () => {
  const inputId = useId();
  const { data, isError, isLoading } = globalAPI.useGetPartnersKeysQuery();

  if (isError) {
    return <ErrorComponent />;
  }
  if (isLoading || !data) {
    return (
      <div style={{ width: '100%', height: '200px', display: 'flex', alignItems: 'center' }}>
        <Loader.Local delay={0} />
      </div>
    );
  }

  return (
    <S.Field>
      <S.Header>3rd Party Audience</S.Header>
      <S.SubTitle>
        Select the partner(s) which you would like to connect to Appnext audience builder. <br />
        Please copy the API key and open your partner&apos;s dashboard for further instructions
      </S.SubTitle>
      {data.map(({ api_key, partner_name }, index) => {
        return (
          <S.InputContainer key={index}>
            <S.IconWrap>
              <ImageWithFallback
                height={24}
                src={`https://selfservice3.appnext.com/Style/Discovery/CustomAudience/${partner_name}-logo-transparent.png`}
              />
            </S.IconWrap>
            <CustomInput
              id={inputId}
              name={inputId}
              value={api_key}
              inputStyle={{ borderRadius: '0' }}
            />
            <S.CopyIconWrap>
              <CopyString
                text={api_key}
                isHidden
                icon={
                  <IconButton.SmallSize
                    isDefaultMuted
                    icon={CopyIcon}
                    type={IconButton.btnTypes.tertiary}
                    onClick={() => {}}
                  />
                }
              />
            </S.CopyIconWrap>
          </S.InputContainer>
        );
      })}
    </S.Field>
  );
};
